import React, { useEffect, useState, useContext, createContext } from 'react'
import productStore from './stores/product'
// import notificationStore from './stores/notification';
// import transactionStore from './stores/transaction'
// import vendorStore from './stores/vendor'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro' // <-- import styles to be used
import Modal from './components/Modal'
import { Text, Select } from './components/Fields'
import Select2 from 'react-select'
import Button from './components/Button'
import Table from './components/Table'
import { produce } from 'immer'
import transactionStore from './stores/transaction';
import regionStore from './stores/region';
import destinationStore from './stores/destination';
import CategorySelect from './components/CategorySelect'
import DestinationSelect from './components/DestinationSelect'
import RegionSelect from './components/RegionSelect'
// import numeral from 'numeral'
// import SortableHeader from './components/SortableHeader'
// import TableToExcel from './lib/table-to-excel'

const KitsContext = createContext()

export default () => {

  const [kitToEdit, setKitToEdit] = useState(false)
  const [kitToDelete, setKitToDelete] = useState(false)
  const [kitToShip, setKitToShip] = useState(false)
  const [kits, setKits] = useState([])
  const [saving, setSaving] = useState(false)
  const [quantity, setQuantity] = useState(0)
  const [warning, setWarning] = useState(false)

  const fetchKits = async () => {
    const response = await fetch('/api/kits')
    const data = await response.json()
    setKits(data)
  }

  const [
    transactionToEdit,
    setTransactionToEdit,
  ] = transactionStore(state => [
    state.transactionToEdit,
    state.setTransactionToEdit,
  ])

  const [regions, fetchRegions] = regionStore(state => [state.collection, state.fetch])
  const [fetchDestinations] = destinationStore(state => [state.fetch])

  const [
    fetchProducts,
    products,
  ] = productStore((state) => [
    state.fetch,
    state.collection,
  ]);

  useEffect(() => {
    fetchKits()
    fetchProducts('no_archive=true')
    fetchDestinations()
    fetchRegions()
  }, [])

  const save = async () => {
    setSaving(true)
    const {id, ...params} = kitToEdit
    const method = id ? 'PUT' : 'POST'
    const url = id ? `/api/kits/${id}` : '/api/kits'
    const response = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    })
    const data = await response.json()
    setSaving(false)
    if (!response.ok) {
      throw new Error(`There was an error saving the kit.\n${JSON.stringify(data, null, 2)}`)
    }
    setKits(produce(kits, draft => {
      const index = draft.findIndex(k => k.id == data.id)
      if (index > -1) {
        draft[index] = data
      } else {
        draft.push(data)
      }
    }))
    setKitToEdit(false)
  }

  const createTransaction = (force = false) => {
    setWarning(false)
    if (transactionToEdit.items_attributes?.length > 0 && !force) {
      return setWarning(true)
    }
    setTransactionToEdit({
      direction: -1,
      category: kitToShip.category,
      region_id: kitToShip.region_id,
      destinations_transactions_attributes: kitToShip.destinations_kits_attributes.map(dk => ({
        destination_id: dk.destination_id,
        percentage: dk.percentage,
      })),
      items_attributes: kitToShip.kits_products_attributes.map(kp => ({
        product: kp.product,
        product_id: kp.product.id,
        quantity: kp.quantity * quantity,
      })),
    })
    setKitToShip(false)
    setQuantity(0)
  }

  return <KitsContext.Provider value={{ setKitToEdit, setKitToDelete, setKitToShip }}>
    <div>
      <div className="flex justify-between gap-4 mb-4 items-end">
        <div className='flex gap-4'>
          <h1 className="text-4xl">Kits</h1>
        </div>
        <div className="flex justify-center gap-4">
          <Button type="success" icon="plus" onClick={() => setKitToEdit({})}>
            <FontAwesomeIcon icon={icon({name: 'plus'})} />
            New Kit
          </Button>
        </div>
      </div>
      <div>
        <Table>
          <Table.Head className="sticky top-0">
            <Table.Row>
              <Table.Th>Name</Table.Th>
              <Table.Th>Category</Table.Th>
              <Table.Th>Destinations</Table.Th>
              <Table.Th>Region</Table.Th>
              <Table.Th>Products</Table.Th>
              <Table.Th></Table.Th>
            </Table.Row>
          </Table.Head>
          <Table.Body>
            {kits.map((kit) => (
              <Row kit={kit} key={kit.id} />
            ))}
          </Table.Body>
        </Table>
      </div>

      <Modal isOpen={kitToShip} onClose={() => setKitToShip(false)}>
        <Modal.Header onClose={() => setKitToShip(false)}>
          Ship {kitToShip.title}
        </Modal.Header>
        <Modal.Body>
          <Text
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            label="Quantity"
            className="mb-4"
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="flex items-center justify-between gap-4">
            <a href="#" onClick={() => {
              setKitToShip(false)
              setQuantity(0)
            }}>
              Cancel
            </a>
            <Button type="success" onClick={() => createTransaction()}>
              <FontAwesomeIcon icon={icon({name: 'box'})} />
              Ship
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal isOpen={warning}>
        <Modal.Header>
          Warning
        </Modal.Header>
        <Modal.Body>
          <p>You have an open transaction. If you continue, the current transaction will be overwritten.</p>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex items-center justify-between gap-4">
            <a href="#" onClick={() => {
              setWarning(false)
              setKitToShip(false)
              setQuantity(0)
            }}>
              Cancel
            </a>
            <Button type="danger" onClick={() => createTransaction(true)}>
              <FontAwesomeIcon icon={icon({name: 'box'})} />
              Proceed
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal isOpen={kitToDelete} onClose={() => setKitToDelete(false)}>
        <Modal.Header onClose={() => setKitToDelete(false)}>
          You Sure?
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete this kit?</p>
          <p>This action cannot be undone.</p>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex items-center justify-between gap-4">
            <a href="#" onClick={() => setKitToDelete(false)}>
              Cancel
            </a>
            <Button type="danger" onClick={async () => {
              const response = await fetch(`/api/kits/${kitToDelete.id}`, {
                method: 'DELETE',
              })
              if (!response.ok) {
                throw new Error('There was an error deleting the kit.')
              }
              setKits(kits.filter(kit => kit.id != kitToDelete.id))
              setKitToDelete(false)
            }}>
              <FontAwesomeIcon icon={icon({name: 'trash'})} />
              Delete
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal isOpen={kitToEdit} onClose={() => setKitToEdit(false)}>
        <Modal.Header onClose={() => setKitToEdit(false)}>
          Editing {kitToEdit.title ? kitToEdit.title : 'New Kit'}
        </Modal.Header>
        <Modal.Body>
          <Text
            value={kitToEdit.title ?? ''}
            onChange={(e) => setKitToEdit({...kitToEdit, title: e.target.value})}
            label="Kit Name"
            className="mb-4"
          />
          <CategorySelect
            onChange={category => setKitToEdit({...kitToEdit, category: category?.value})}
            value={kitToEdit.category}
          />
          <DestinationSelect
            onChange={(destinations, lastSelected) => {
              const newKit = {
                ...kitToEdit,
                destinations_kits_attributes: destinations,
              }
              if (!kitToEdit.region_id) {
                newKit.region_id = regions.find(r => r.uuid == lastSelected?.id_Region)?.value
              }
              setKitToEdit(newKit)
            }}
            value={kitToEdit.destinations_kits_attributes ?? []}
            allowDeleteLast
          />
          <RegionSelect
            onChange={region => setKitToEdit({...kitToEdit, region_id: region?.value})}
            value={kitToEdit.region_id}
          />
          <Table className="mb-4">
            <Table.Head>
              <Table.Row>
                <Table.Th>Product</Table.Th>
                <Table.Th width="60">Quantity</Table.Th>
                <Table.Th width="1">
                  <Button type="success" onClick={() =>
                    setKitToEdit({...kitToEdit, kits_products_attributes: [...kitToEdit.kits_products_attributes ?? [], {quantity: 1}]})
                  }>
                    <FontAwesomeIcon icon={icon({name: 'plus'})} />
                  </Button>
                </Table.Th>
              </Table.Row>
            </Table.Head>
            <Table.Body>
              {kitToEdit?.kits_products_attributes?.map((product, index) => {
                if (product._destroy) return null
                const value = products.find(p => p.id == product.product_id)
                return <Table.Row key={index}>
                  <Table.Td>
                    <Select2
                      options={products}
                      onChange={product => setKitToEdit(produce(kitToEdit, draft => {
                        draft.kits_products_attributes[index].product_id = product?.value
                      }))}
                      filterOption={(candidate, input) => {
                        if (!input) return true
                        const parts = input.split(' ')
                        for (const part of parts) {
                          if (!candidate.label.toLowerCase().includes(part.toLowerCase())) return false
                        }
                        return true
                      }}
                      value={value}
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                      isClearable
                    />
                  </Table.Td>
                  <Table.Td>
                    <Text
                      type="number"
                      value={product.quantity}
                      onChange={e => setKitToEdit(produce(kitToEdit, draft => {
                        draft.kits_products_attributes[index].quantity = e?.target?.value
                      }))}
                    />
                  </Table.Td>
                  <Table.Td>
                    <Button type="danger" onClick={() => {
                      setKitToEdit(produce(kitToEdit, draft => {
                        draft.kits_products_attributes[index]['_destroy'] = true
                      }))
                    }}>
                      <FontAwesomeIcon icon={icon({name: 'trash'})} />
                    </Button>
                  </Table.Td>
                </Table.Row>
              })}
            </Table.Body>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex items-center justify-between gap-4">
            <a href="#" onClick={() => setKitToEdit(false)}>
              Cancel
            </a>
            <Button type="success" onClick={save} disabled={saving}>
              <FontAwesomeIcon icon={icon({name: 'save'})} />
              Save
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  </KitsContext.Provider>
}

const Row = ({kit}) => {

  const { setKitToEdit, setKitToDelete, setKitToShip } = useContext(KitsContext)
  const [menuOpen, setMenuOpen] = useState(false)
  const [destinations] = destinationStore(state => [state.collection])

  useEffect(() => {
    const closeMenu = (e) => {
      if (!e.target.closest('.relative')) {
        setMenuOpen(false)
      }
    }
    document.addEventListener('click', closeMenu)
    return () => {
      document.removeEventListener('click', closeMenu)
    }
  }, [])

  const [regions] = regionStore(state => [state.collection])

  const handleDelete = () => {
    setMenuOpen(false)
    setKitToDelete(kit)
  }

  const handleEdit = () => {
    setMenuOpen(false)
    setKitToEdit(kit)
  }

  return <Table.Row>
    <Table.Td>{kit.title}</Table.Td>
    <Table.Td>{kit.category}</Table.Td>
    <Table.Td>
      <ul>
        {kit.destinations_kits_attributes.map(dk => <li key={dk.id}>
          <span className="font-bold">{destinations.find(d => d.id == dk.destination_id)?.name}</span> - {dk.percentage}%
        </li>)}
      </ul>
    </Table.Td>
    <Table.Td>{regions.find(r => r.value == kit.region_id)?.label}</Table.Td>
    <Table.Td>
      <ul>
        {kit.kits_products_attributes.map(product => <li title={product.product.sku} key={product.id}>
          <span className="font-bold">{product.quantity}</span> - {product.product.title}
        </li>)}
      </ul>
    </Table.Td>
    <Table.Td width="1">
      <div className="flex gap-4 items-center">
        <Button onClick={() => setKitToShip(kit)}>
          <FontAwesomeIcon icon={icon({name: 'box'})} />
          Ship
        </Button>
        <div className="relative">
          <button onClick={() => setMenuOpen(old => !old)} className="p-2"><FontAwesomeIcon icon={icon({name: 'ellipsis-v'})} /></button>
          {menuOpen && <div className="absolute right-0 top-full bg-white shadow-md rounded-md z-10">
            <button className="flex items-center gap-2 p-2" onClick={handleEdit}>
              <FontAwesomeIcon icon={icon({name: 'edit'})} />
              Edit
            </button>
            <button className="flex items-center gap-2 text-red-500 p-2" onClick={handleDelete}>
              <FontAwesomeIcon icon={icon({name: 'trash'})} />
              Delete
            </button>
          </div>}
        </div>
      </div>
    </Table.Td>
  </Table.Row>
}

